import {defineStore} from 'pinia';
import {ModuleFundStructure} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import fundStructureAPI from '@/apis/di/fundStructureAPI.js';
const fundStructureStore = new BaseDictionaryStore(fundStructureAPI);
/**
 * Store danh mục nội dung chi phí
 * ndhieu3 13.04.2023
 */
export const useFundStructureStore = defineStore(ModuleFundStructure, {
  state: () => ({
    ...fundStructureStore.state,
    _config: {
      key: 'fund_structure_id',
      code: 'fund_structure_code',
      name: 'fund_structure_name',
      table: 'di_fund_structure',
      moduleName: 'Nội dung chi phí',
      quickFollow: 'active',
      defaultSort: 'fund_structure_code',
      isTree: true,
    },
  }),
  actions: {...fundStructureStore.action},
  getters: {
    ...fundStructureStore.getters,
  },
});
